<template>
    <b-modal 
        id="modal-pilih-anggota" 
        size="xl" 
        title="Pilih Anggota" 
        @shown="focusInputSubmit" 
        no-close-on-esc 
        no-close-on-backdrop
        modal-class="custom-pilih-anggota-modal"
        header-class="pilih-anggota-modal-header"
        body-class="pilih-anggota-modal-body"
        footer-class="pilih-anggota-modal-footer"
    >
        <!-- Filter / Search Section -->
        <div class="search-section mb-4">
            <div class="search-eyebrow mb-2">CARI BERDASARKAN</div>
            <div class="search-controls-row">
                <!-- Segmented Tabs -->
                <div class="search-tab-nav">
                    <button 
                        type="button" 
                        class="search-tab-btn" 
                        :class="{ active: searchBy === 2 }" 
                        @click="setSearchBy(2)"
                    >
                        Nama Anggota
                    </button>
                    <button 
                        type="button" 
                        class="search-tab-btn" 
                        :class="{ active: searchBy === 1 }" 
                        @click="setSearchBy(1)"
                    >
                        No. NIK
                    </button>
                    <button 
                        type="button" 
                        class="search-tab-btn" 
                        :class="{ active: searchBy === 3 }" 
                        @click="setSearchBy(3)"
                    >
                        No. Anggota
                    </button>
                </div>

                <!-- Search Input Box -->
                <b-form-input 
                    v-model="searchQuery" 
                    ref="inputAnggotaSearch" 
                    v-on:keyup.enter="searchAnggota" 
                    name="gadaiSearchAnggota" 
                    :placeholder="searchPlaceholder"
                    class="search-input-field"
                ></b-form-input>

                <!-- Optional Tanggal Lahir Input if searchBy == 2 -->
                <b-form-input 
                    v-if="showSearchTanggalLahir"
                    v-model="searchByTglLahir" 
                    name="filterTanggalLahir"
                    type="date"
                    class="search-date-input"
                ></b-form-input>

                <!-- Search Button -->
                <button 
                    type="button" 
                    class="btn btn-search-icon" 
                    name="anggotaSearchBtn" 
                    :disabled="isBusy" 
                    @click="searchAnggota"
                >
                    <i class="fa fa-search"></i>
                </button>
            </div>
            <div v-if="showSearchTanggalLahir" class="text-muted small mt-1">
                Nama anggota <b>WAJIB</b> diisi. Tanggal lahir bersifat opsional (tidak harus isi, namun bila diisi harus lengkap).
            </div>
        </div>

        <!-- Table Data -->
        <div class="table-responsive-wrapper">
            <b-table 
                hover 
                show-empty 
                :fields="fields" 
                :busy="isBusy" 
                :items="items" 
                responsive 
                class="custom-modal-table mb-0"
            >
                <template v-slot:table-busy>
                    <div class="text-center text-muted my-4 py-3">
                        <b-spinner class="align-middle mr-2" variant="primary" small></b-spinner>
                        <span>Mengambil data anggota...</span>
                    </div>
                </template>
                <template v-slot:empty>
                    <div class="text-center py-4 text-muted">
                        Tidak menemukan anggota dengan kriteria pencarian diatas.
                    </div>
                </template>

                <!-- Slot: NAMA ANGGOTA -->
                <template v-slot:cell(nama)="row">
                    <span class="member-name-text">{{ row.item.nama }}</span>
                </template>

                <!-- Slot: NO. IDENTITAS -->
                <template v-slot:cell(noIdentitas)="row">
                    <span class="member-info-text">{{ row.item.noIdentitas || '-' }}</span>
                </template>

                <!-- Slot: NO. ANGGOTA -->
                <template v-slot:cell(no)="row">
                    <span class="member-info-text">{{ row.item.no || '-' }}</span>
                </template>

                <!-- Slot: AKSI -->
                <template v-slot:cell(action)="row">
                    <div class="text-center">
                        <button 
                            type="button" 
                            class="btn btn-pilih-anggota" 
                            name="pilihAnggotaBtn" 
                            @click="selectAnggota(row.item)"
                        >
                            Pilih
                        </button>
                    </div>
                </template>
            </b-table>
        </div>

        <!-- Modal Footer -->
        <template v-slot:modal-footer="{ cancel }">
            <div class="d-flex align-items-center justify-content-between w-100">
                <span class="entries-info-text">{{ totalViewText }}</span>
                <div class="d-flex align-items-center">
                    <b-pagination 
                        v-if="rows > show"
                        class="custom-pagination mb-0 mr-3"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                        prev-text="‹"
                        next-text="›"
                        hide-goto-end-buttons
                    ></b-pagination>
                    <button 
                        type="button" 
                        class="btn btn-modal-tutup" 
                        name="cancelPilihAnggotaBtn" 
                        @click="cancel()"
                    >
                        Tutup
                    </button>
                </div>
            </div>
        </template>            
    </b-modal>
</template>

<script>
export default {
    name: 'modal-pilih-anggota',
    data() {
        return {
            searchQuery: "",
            searchBy: 2, // Default: Nama Anggota
            searchByTglLahir: null,
            show: 10,

            fields: [
                { key: "nama", label: "NAMA ANGGOTA", class: "align-middle" },
                { key: "noIdentitas", label: "NO. IDENTITAS", class: "align-middle" },
                { key: "no", label: "NO. ANGGOTA", class: "align-middle" },
                { key: "action", label: "AKSI", class: "align-middle text-center" },
            ],
            showSearchTanggalLahir: false,
            items: [],
            isBusy: false,
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],
        }
    },
    computed: {
        searchPlaceholder() {
            if (this.searchBy === 1) return "Masukkan no. NIK"
            if (this.searchBy === 3) return "Masukkan no. anggota"
            return "Masukkan nama anggota"
        }
    },
    watch: {
        "searchBy": function(newValue) {
            this.showSearchTanggalLahir = newValue == 2
        }
    },
    methods: {
        setSearchBy(id) {
            this.searchBy = id
            this.$nextTick(() => {
                this.focusInputSubmit()
            })
        },

        getListAnggota() {
            if (this.searchQuery == "") {
                this.$helper.toastErr(this, "Mohon isi pencarian (minimal 3 karakter)")
            } else {
                if (this.searchBy == 2) {
                    this.query = `?query=${this.searchQuery}&searchBy=${this.searchBy}&page=${this.currentPage - 1}&size=${this.show}`
                    if (this.$helper.isNotNullAndNotEmpty(this.searchByTglLahir)) {
                        this.query += "&tanggalLahir=" + this.searchByTglLahir
                    }
                } else {
                    this.query = `?query=${this.searchQuery}&searchBy=${this.searchBy}&page=${this.currentPage - 1}&size=${this.show}`
                }
                this.isBusy = true
                this.$axios.get(`nasabah/findForGadai` + this.query).then(response => {
                    this.items = response.data.data
                    this.updateTotalItem(response.data.total)
                })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })
            }
        },

        searchAnggota() {
            this.currentPage = 1
            this.getListAnggota()
        },

        onReset() {
            this.searchQuery = ""
            this.searchBy = 2
            this.searchByTglLahir = null
            this.items = []
        },

        selectAnggota(item) {
            this.$emit("anggota-selected", item)
        },

        onLimitChange() {
            this.perPage = this.show
            this.onPageChange()
        },

        onPageChange() {
            this.getListAnggota()
            let prevLimit = (this.currentPage - 1) * this.show + 1
            let limit = (this.currentPage - 1) * this.show + this.show
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan " + prevLimit + " - " + limit + " dari " + this.$helper.addThousandSeparator(this.rows) + " anggota"
        },

        updateTotalItem(total) {
            let limit = null
            let prevLimit = null
            this.perPage = this.show
            this.rows = total
            prevLimit = (this.currentPage - 1) * this.show + 1
            limit = (this.currentPage - 1) * this.show + this.show
            if (limit > this.rows) limit = this.rows
            if (total === 0) {
                this.totalViewText = "Menampilkan 0 dari 0 anggota"
            } else {
                this.totalViewText = "Menampilkan " + prevLimit + " - " + limit + " dari " + this.$helper.addThousandSeparator(this.rows) + " anggota"
            }
        },

        focusInputSubmit() {
            if (this.$refs.inputAnggotaSearch && this.$refs.inputAnggotaSearch.$el) {
                this.$refs.inputAnggotaSearch.$el.focus()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
// Design Tokens (Deep Pine Palette)
$deep-pine: #023831;
$deep-pine-dark: #072D28;
$deep-pine-hover: #0A5247;
$sage-header-bg: #F5FAF7;
$ink-body: #16302B;
$ink-heading: #072D28;
$ink-muted: #7E918B;
$line-border: #E2E7E3;
$input-border: #D8E2DC;

// 1. Search Section
.search-section {
    .search-eyebrow {
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.12em;
        color: $ink-muted;
        text-transform: uppercase;
    }

    .search-controls-row {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;

        // Segmented Switcher
        .search-tab-nav {
            display: inline-flex;
            background-color: #F0F4F2;
            border-radius: 8px;
            padding: 3px;

            .search-tab-btn {
                border: none;
                background: transparent;
                padding: 6px 14px;
                font-size: 12.5px;
                font-weight: 600;
                color: #4A5D56;
                border-radius: 6px;
                cursor: pointer;
                transition: all 0.2s ease;
                outline: none !important;

                &:hover:not(.active) {
                    color: $ink-heading;
                    background-color: rgba(2, 56, 49, 0.05);
                }

                &.active {
                    background-color: $deep-pine;
                    color: #FFFFFF;
                    box-shadow: 0 1px 3px rgba(2, 56, 49, 0.15);
                }
            }
        }

        .search-input-field {
            flex: 1;
            min-width: 240px;
            height: 38px;
            border-radius: 8px;
            border: 1px solid $input-border;
            font-size: 13px;
            color: $ink-body;
            padding: 6px 14px;
            transition: all 0.2s;

            &::placeholder {
                color: #8C9F98;
                font-size: 12.5px;
            }

            &:focus {
                border-color: $deep-pine;
                box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
                outline: none;
            }
        }

        .search-date-input {
            width: 150px;
            height: 38px;
            border-radius: 8px;
            border: 1px solid $input-border;
            font-size: 12.5px;
            color: $ink-body;
            padding: 4px 10px;

            &:focus {
                border-color: $deep-pine;
                outline: none;
            }
        }

        .btn-search-icon {
            width: 40px;
            height: 38px;
            background-color: $deep-pine;
            border: 1px solid $deep-pine;
            color: #FFFFFF;
            border-radius: 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            transition: all 0.2s;

            &:hover:not(:disabled) {
                background-color: $deep-pine-hover;
                border-color: $deep-pine-hover;
            }

            &:disabled {
                opacity: 0.7;
                cursor: not-allowed;
            }
        }
    }
}

// 2. Table Modernization
.table-responsive-wrapper {
    overflow-x: auto;
}

.custom-modal-table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;

    ::v-deep thead th {
        background-color: $sage-header-bg;
        border-top: none;
        border-bottom: 1px solid $line-border;
        font-size: 11px;
        font-weight: 700;
        color: #4A5D56;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        padding: 12px 16px;
        vertical-align: middle;
        white-space: nowrap;
    }

    ::v-deep tbody tr {
        transition: background-color 0.15s ease;

        &:hover {
            background-color: #F8FAF9;
        }

        td {
            padding: 14px 16px;
            border-top: 1px solid #EDF2EF;
            border-bottom: none;
            vertical-align: middle;
        }

        &:first-child td {
            border-top: none;
        }
    }
}

.member-name-text {
    font-weight: 700;
    color: $ink-heading;
    font-size: 13.5px;
}

.member-info-text {
    font-size: 13px;
    color: $ink-body;
    font-weight: 500;
}

.btn-pilih-anggota {
    height: 32px;
    padding: 0 18px;
    background-color: #FFFFFF;
    border: 1.5px solid $deep-pine;
    color: $deep-pine;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    outline: none !important;

    &:hover {
        background-color: $deep-pine;
        color: #FFFFFF;
        box-shadow: 0 1px 3px rgba(2, 56, 49, 0.2);
    }
}

// 3. Footer
.entries-info-text {
    font-size: 12.5px;
    color: $ink-muted;
}

.btn-modal-tutup {
    height: 36px;
    padding: 0 22px;
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    transition: all 0.2s ease;
    outline: none !important;

    &:hover {
        background-color: #F4F7F5;
        border-color: #BAC9C2;
        color: $ink-heading;
    }
}

// Bootstrap Vue Pagination Override
.custom-pagination {
    ::v-deep .page-item {
        margin: 0 2px;

        .page-link {
            border-radius: 6px !important;
            border: 1px solid $input-border;
            color: $ink-body;
            font-size: 12px;
            font-weight: 500;
            min-width: 32px;
            height: 32px;
            padding: 0 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background-color: #FFFFFF;
            transition: all 0.15s ease;
            box-shadow: none !important;

            &:hover {
                background-color: #F4F7F5;
                border-color: #BAC9C2;
                color: $ink-heading;
            }
        }

        &.active .page-link {
            background-color: $deep-pine !important;
            border-color: $deep-pine !important;
            color: #FFFFFF !important;
            font-weight: 700;
        }

        &.disabled .page-link {
            opacity: 0.45;
            background-color: #FAFCFA;
            border-color: #E2E7E3;
            color: #A0B0AA;
            cursor: not-allowed;
        }
    }
}
</style>